import { getTvObject, tv } from '@costar-ui/cosmos';

var selectTV = getTvObject({
  slots: {
    base: 'group relative w-full gap-1 text-on-base',
    label: 'w-full',
    button: ['w-full', 'items-center', 'text-left', 'px-2 py-1', 'hover:border-hover', 'hover:bg-action-base', 'pressed:bg-action-base', 'pressed:border-focus', 'focus:border-focus', 'focus-visible:border-focus'],
    subText: 'w-full text-neutral-strong',
    listBox: 'max-h-[400px] w-full max-w-[300px]',
    gridListItem: ''
  },
  variants: {
    variant: {
      outlined: {
        button: 'h-8 border-neutral',
        //height 32px
        base: 'text-p-16',
        listBox: 'text-p-16',
        gridListItem: 'h-8 px-2 py-1.5'
      },
      ghost: {
        base: 'text-p-16',
        button: 'h-8 border-transparent text-p-16',
        // height 32px
        listBox: 'text-p-16',
        gridListItem: 'h-8 px-2 py-1.5'
      },
      'ghost-sm': {
        base: 'text-p-14',
        button: 'h-6 border-transparent px-2 py-1 text-p-14',
        //height 24px
        listBox: 'text-p-14',
        gridListItem: 'h-6 px-2 py-1'
      },
      'ghost-xs': {
        base: 'text-p-12',
        button: 'h-5 border-transparent px-2 py-0.5 text-p-12',
        //height 20px
        listBox: 'text-p-12',
        gridListItem: 'h-5 px-2 py-0.5'
      }
    },
    layout: {
      grid: {
        base: 'flex flex-col'
      },
      relative: {
        label: 'absolute -translate-y-full leading-5',
        subText: 'absolute bottom-0 translate-y-full'
      }
    },
    screenReaderOnly: {
      "true": {
        label: 'sr-only',
        subText: 'sr-only'
      }
    },
    isDisabled: {
      "false": {
        base: 'group-disabled:text-action-disabled',
        button: 'group-invalid:border-status-negative'
      }
    }
  }
});
var base = tv(selectTV);
var selectStyles = {
  base: base
};

export { selectStyles, selectTV };
//# sourceMappingURL=select.styles.esm.js.map
